'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('admin', {
    url: '/admin/users',
    template: require('./admin.html'),
    controller: 'AdminController',
    controllerAs: 'admin',
    authenticate: 'suite-admin'
  });
}



// WEBPACK FOOTER //
// ./client/app/admin/user-list/admin.routes.js